module.exports = __webpack_public_path__ + "static/media/powWowLogo.d22b075b.png";